import { useState } from "react";
import MainLayout from "../../components/MainLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Helmet } from "react-helmet-async";
import "./privacy.css";

import brandConfig from "../../config/brand.config";
interface Section {
  id: string;
  title: string;
  content: React.ReactNode;
}

const sections: Section[] = [
  {
    id: "kebijakan_privasi",
    title: "Kebijakan Privasi",
    content: (
      <>
        <p>
          Kebijakan privasi ini menjelaskan bagaimana perusahaan kami, PT
          Sahabat Olah Duit mengumpulkan, menyimpan, memproses dan/atau
          mengungkapkan informasi data pribadi Anda. Kami menganggap privasi
          Anda dan keamanan data pribadi Anda sebagai prioritas kami. Karena
          kami mengetahui bahwa informasi tersebut dapat mencakup data pribadi
          Anda yang berkaitan dengan atau terkait dengan individu tertentu
          seperti nama, nomor telepon, dan alamat email. Kami menggunakan data
          ini untuk meningkatkan Layanan Kami.
        </p>
        <p>
          {brandConfig.appName} tersedia (a) melalui Situs Web {brandConfig.appName} "{brandConfig.prodUrl}" di
          mana Anda dapat menemukan, memesan, membeli berbagai Aktivitas yang
          sesuai dengan minat Anda; (b) melalui Situs Web {brandConfig.appName}
          "{brandConfig.prodUrl}” merupakan tempat Anda dapat membuat acara, mengelola
          acara, dan menjual Tiket acara; (c) Layanan Offline kami "Sistem
          Manajemen Tiket" dengan RFID, manajemen Tiket masuk, manajemen
          Sponsor, layanan percetakan Tiket, dan layanan pemasaran; (d) melalui
          "Application Programming Interfaces" yang membangun subsistem terpisah
          yang memiliki fungsi berguna oleh subsistem lain untuk mengakses
          fungsi; (a), (b), (c) dan (d) secara kolektif disebut sebagai "Layanan
          Kami".
        </p>
        <p>
          Layanan Kami dimiliki oleh PT Sahabat Olah Duit ("Perusahaan",
          "Kami"). Sebagai penyedia layanan, Kami akan mengelola transaksi
          pemesanan dan pembayaran untuk Tiket Kegiatan (seperti Acara, Bioskop,
          Tur, dan Atraksi) yang tersedia melalui Layanan Kami. Pemilik dari
          setiap Aktivitas adalah Merchant (misalnya, Promotor Acara, Pemilik
          Acara, Penyelenggara Acara, Operator Tempat, dan sebagainya).
          Sementara itu, orang yang membeli atau mendaftar untuk Tiket Aktivitas
          melalui Layanan Kami disebut Pelanggan (misalnya, pembeli, pengunjung,
          peserta Aktivitas, dan lain-lain). Oleh karena itu, baik Anda membeli
          atau menjual Tiket melalui Layanan Kami, Perjanjian ini mengatur akses
          dan penggunaan Layanan Kami oleh Anda sebagai Pengguna.
        </p>
        <p>
          Dengan menggunakan 'Layanan Kami', Anda menerima praktik yang
          dijelaskan dalam Kebijakan Privasi ini. Harap baca Kebijakan Privasi
          ini dengan cermat. Kami dapat memperbarui, mengubah, atau memodifikasi
          kebijakan privasi ini dari waktu ke waktu dan, jika Anda memiliki
          pertanyaan, komentar, atau permintaan apa pun terkait dengan kebijakan
          privasi ini, hubungi kami dengan menggunakan detail kontak di bawah
          ini. Jika Anda tidak setuju dengan ketentuan Kebijakan Privasi, mohon
          untuk tidak menggunakan Layanan Kami.
        </p>
        <p>Kebijakan privasi ini terakhir diperbarui pada 01 Januari 2025.</p>
      </>
    ),
  },
  {
    id: "informasi_yang_kami_kumpulkan_dari_anda",
    title: "Informasi yang Kami Kumpulkan dari Anda",
    content: (
      <>
        <p>
          Kami memiliki kebijakan dimana mengizinkan Anda untuk memposting,
          mengunggah, menerbitkan, mengirimkan, atau mengirimkan informasi
          profil, komentar, pertanyaan, umpan balik, gambar, dan konten lain
          atau informasi. Kami dapat mengumpulkan informasi berikut tentang Anda
          yang Anda berikan kepada kami saat menggunakan Layanan Kami:
        </p>
        <ul>
          <li>
            Informasi pribadi Anda (nama, alamat email, nomor telepon, dan data
            apa pun yang dibutuhkan pedagang kami terkait dengan tiket yang Anda
            beli) yang Anda lengkapi dengan mengisi formulir di Layanan Kami,
            termasuk jika Anda mendaftar sebagai pengguna Layanan Kami,
            berlangganan layanan apa pun, mengunggah atau mengirimkan materi apa
            pun, meminta informasi apa pun, atau mengikuti kompetisi atau
            promosi apa pun yang mungkin kami sponsori;
          </li>
          <li>
            Sehubungan dengan fasilitas masuk akun, kata sandi dan detail masuk
            Anda;
          </li>
          <li>
            Informasi organisasi Anda. Kami akan mengumpulkan nama Anda, peran
            Anda, nama organisasi, detail lokasi organisasi sebagai bagian dari
            kontrak untuk menyediakan layanan pendaftaran Aktivitas (acara)
            kepada Anda. Selain itu, untuk layanan pemrosesan pembayaran, kami
            akan mengumpulkan informasi keuangan dari Anda;
          </li>
          <li>
            Data Pribadi tambahan (ukuran baju, golongan darah, KTP, tinggi
            badan, dll) dari Anda, terkadang untuk keperluan kami sendiri dan
            terkadang atas nama Merchant. Kami juga dapat mengumpulkan atau
            menerima Data Pribadi dari sumber pihak ketiga, seperti Pedagang,
            Pelanggan lain, media sosial atau integrasi pihak ketiga lainnya,
            mitra pemrosesan pembayaran kami, atau pihak ketiga lainnya;
          </li>
          <li>
            Preferensi Anda, yang membantu kami memberi Anda penawaran yang
            lebih disesuaikan;
          </li>
          <li>
            Perincian setiap transaksi yang Anda lakukan melalui Layanan Kami;
          </li>
          <li>
            Komunikasi yang Anda kirimkan kepada kami, misalnya, untuk
            melaporkan masalah atau untuk mengajukan pertanyaan, kekhawatiran,
            atau komentar mengenai Layanan Kami atau kontennya;
          </li>
          <li>
            Informasi dari survei yang kami dapat, dari waktu ke waktu, dan
            dilakukan melalui Layanan Kami untuk tujuan penelitian, jika Anda
            memilih untuk menanggapi perihal survey tersebut;
          </li>
          <li>
            Perincian kunjungan Anda di Layanan Kami, sumber daya yang Anda
            akses, dan data apa pun yang Anda unduh;
          </li>
          <li>
            Perincian penggunaan Anda atas Situs Web ini (termasuk data lalu
            lintas, data lokasi, dan lama sesi pengguna);
          </li>
          <li>
            Jika Anda melakukan pembelian, informasi keuangan Anda (seperti
            nomor kartu kredit atau debit Anda);
          </li>
          <li>
            Data non-pribadi. Untuk tujuan kebijakan privasi ini, "data
            non-pribadi" berarti informasi yang tidak mengidentifikasi Anda
            secara langsung. Selain itu, data non-pribadi berarti informasi
            "agregat" dan "tidak dipersonalisasi", yaitu data yang kami
            kumpulkan tentang penggunaan layanan Kami, termasuk data pribadi apa
            pun telah dihapus. Kami dapat menggunakan alat atau perangkat lunak
            analitik pihak ketiga untuk secara otomatis mengumpulkan dan
            menggunakan data non-pribadi tertentu yang tidak secara langsung
            memungkinkan kami untuk mengidentifikasi Anda. Jenis data
            non-pribadi yang kami kumpulkan dan gunakan termasuk, namun tidak
            terbatas pada:
            <ul>
              <li>
                Properti perangkat, termasuk, namun tidak terbatas pada alamat
                IP, alamat Kontrol Akses Media ("MAC") dan pengenal perangkat
                unik atau lainnya pengenal perangkat("UDID");
              </li>
              <li>Platform perangkat lunak dan firmware;</li>
              <li>Operator telepon seluler;</li>
              <li>Data geografis seperti kode pos dan lokasi kasar;</li>
              <li>
                Data non-pribadi lainnya sebagaimana diperlukan secara wajar
                oleh untuk meningkatkan produk dan layanan kami.
              </li>
            </ul>
          </li>
          <li>
            Masukkan dan tanggapan terhadap survei yang kami lakukan terkait
            dengan Layanan Kami.
          </li>
          <li>
            Informasi yang diperoleh dari profil jejaring sosial Anda, jika Anda
            masuk melalui situs jejaring sosial.
          </li>
        </ul>
        <p>
          Anda tidak berkewajiban untuk memberikan informasi tersebut. Namun,
          jika Anda harus memilih untuk menahan informasi yang diminta, kami
          mungkin tidak dapat memberikan layanan tertentu kepada Anda.
        </p>
      </>
    ),
  },
  {
    id: "penggunaan_informasi_anda",
    title: "Penggunaan Informasi Anda",
    content: (
      <>
        <p>Kami akan menggunakan informasi yang Anda berikan untuk:</p>
        <ul>
          <li>
            Membantu kami membangun profil preferensi Anda sehingga kami dapat
            menawarkan aktivitas yang Anda minati;
          </li>
          <li>
            Untuk memastikan proses operasional yang lancar secara keseluruhan –
            data pribadi Anda membantu kami untuk terus meningkatkan Layanan
            Kami;
          </li>
          <li>
            Mempersonalisasi pengalaman pengguna. Kami dapat menggunakan Data
            Pribadi secara agregat untuk memahami bagaimana Pengguna kami
            sebagai kelompok menggunakan layanan dan sumber daya yang disediakan
            di Layanan kami;
          </li>
          <li>
            Berusaha untuk meningkatkan Layanan Kami. Saat Anda mengakses
            Layanan Kami, kami dapat secara otomatis merekam informasi tertentu
            dari sistem Anda dengan menggunakan cookie dan jenis teknologi
            pelacakan lainnya. Informasi yang dikumpulkan secara otomatis ini
            dapat mencakup alamat Protokol Internet (Alamat IP), ID pengguna
            unik, jenis perangkat, pengidentifikasi perangkat, jenis dan bahasa
            browser, halaman rujukan dan keluar, jenis platform, versi perangkat
            lunak yang diinstal, jenis sistem, konten dan halaman yang Anda
            akses pada Layanan, jumlah klik, jumlah waktu yang dihabiskan di
            halaman, tanggal dan waktu Anda mengunjungi Layanan, dan informasi
            serupa lainnya. Bergantung pada hukum negara tempat tinggal Anda,
            alamat IP Anda secara hukum dapat dianggap sebagai Data Pribadi;
          </li>
          <li>Mengidentifikasi pengunjung Layanan Kami;</li>
          <li>
            Melakukan penelitian tentang demografi pengguna kami dan pelacakan
            data penjualan;
          </li>
          <li>
            Untuk memproses transaksi, termasuk pembelian tiket. Kami dapat
            menggunakan Data Pribadi yang Pengguna berikan tentang diri mereka
            sendiri saat melakukan pemesanan hanya untuk menyediakan layanan
            atas pesanan tersebut. Kami tidak membagikan informasi ini dengan
            pihak luar kecuali sejauh yang diperlukan untuk menyediakan layanan;
          </li>
          <li>
            Pembayaran aman kami tidak memiliki akses ke detail pembayaran
            lengkap Anda, tetapi kami dapat merujuk ke sebagian informasi,
            seperti beberapa digit terakhir nomor kartu kredit Anda, untuk
            tujuan autentikasi dan anti-penipuan;
          </li>
          <li>
            Untuk menjaga komunikasi pemasaran, Jika sesuai dengan preferensi
            pemasaran Anda, kami dapat menggunakan Data Pribadi Anda untuk
            menghubungi Anda di masa mendatang untuk tujuan pemasaran dan
            periklanan kami, termasuk tanpa batasan, untuk memberi tahu Anda
            tentang layanan atau acara yang kami yakini mungkin menarik bagi
            Anda, untuk mengembangkan materi promosi atau pemasaran dan
            memberikan materi tersebut kepada Anda, dan untuk menampilkan konten
            dan iklan di dalam atau di luar Layanan yang kami yakini mungkin
            menarik bagi Anda;
          </li>
          <li>
            Untuk memfasilitasi komunikasi Merchant - Kami mengizinkan Merchant
            untuk menggunakan alat email kami untuk menghubungi Pelanggan untuk
            acara mereka saat ini dan di masa lalu, sehingga Anda dapat menerima
            email dari sistem kami yang berasal dari Merchant tersebut dan yang
            kami kirimkan atas nama mereka. Jika Anda mendaftar untuk suatu
            acara di Layanan, alamat email Anda tersedia untuk Penjual tersebut.
            Namun, Penjual juga dapat mengimpor alamat email yang mereka miliki
            dari sumber eksternal dan mengirimkan komunikasi melalui Layanan ke
            alamat email tersebut, dan kami akan mengirimkan komunikasi tersebut
            ke alamat email tersebut atas nama Penjual. Merchant bertanggung
            jawab untuk mengirimkan email-email ini, bukan Kami;
          </li>
          <li>
            Untuk memberikan dukungan. Kami dapat menggunakan Data Pribadi Anda
            saat memberi Anda dukungan pelanggan atau teknis;
          </li>
          <li>
            Bantuan pelanggan untuk memudahkan komunikasi Anda dengan pedagang
            kami, kami menggunakan data pribadi Anda, seperti nama, email, dan
            nomor telepon Anda untuk:
            <ul>
              <li>
                Membangun identitas Anda dengan cepat dan aman dan terhubung
                langsung ke riwayat pesanan Anda.
              </li>
              <li>Menukarkan tiket yang Anda beli dari Layanan Kami.</li>
              <li>
                Melengkapi informasi e-tiket yang Anda beli dari Layanan Kami.
              </li>
              <li>
                Fasilitasi tindak lanjut melalui telepon, email, atau WhatsApp.
                Ketika kami yakin Anda mungkin memerlukan bantuan kami yaitu
                jika Anda ingin melakukan transaksi selama tahap akhir dari
                proses pemesanan. Kami kemudian menggunakan data pribadi Anda
                untuk menanyakan apakah Anda memerlukan bantuan.
              </li>
              <li>
                Menghubungi Anda untuk memberi tahu Anda tentang keadaan apa pun
                yang berada di luar kendali kami yang dapat memengaruhi
                pengalaman Anda dengan Layanan Kami;
              </li>
            </ul>
          </li>
          <li>
            Berbagi dengan pihak ketiga jika diperlukan untuk memproses
            transaksi Anda dengan kami, seperti perusahaan kartu kredit, bank,
            dan petugas operator tiket;
          </li>
          <li>
            Bertukar informasi dengan perusahaan lain untuk perlindungan
            penipuan dan pengurangan risiko kredit;
          </li>
          <li>Mengaudit pengunduhan data dari Aplikasi;</li>
          <li>
            Meningkatkan tata letak dan/atau konten halaman Layanan Kami dan
            menyesuaikannya untuk pengguna;
          </li>
          <li>
            Tujuan pemasaran ini berawal dari komunikasi semi-pribadi termasuk
            buletin dan promosi dari apa yang kami tawarkan di Layanan atau
            survei Kami. Ini hanya boleh dilakukan dengan persetujuan Anda dan
            kebijakan pemasaran langsung kami yang dijelaskan secara lengkap di
            bawah ini.;
          </li>
          <li>Berbagi dengan situs jejaring sosial atas permintaan Anda;</li>
          <li>
            Mematuhi hukum secara keseluruhan - data pribadi Anda juga memainkan
            peran kunci dalam membantu kami mengidentifikasi dan mencegah
            transaksi penipuan atau perilaku ilegal lainnya saat mengunjungi
            dan/atau menggunakan Layanan Kami, mengomunikasikan pesan keamanan
            kepada pelanggan kami, dan mematuhi hukum dan peraturan terkait yang
            berlaku.
          </li>
        </ul>
        <p>
          Kami hanya akan menyimpan data pribadi Anda sementara untuk tujuan
          yang tercantum di atas, kecuali untuk situasi di mana undang-undang
          atau peraturan menentukan sebaliknya.
        </p>
      </>
    ),
  },
  {
    id: "informasi_tambahan",
    title: "Informasi Tambahan",
    content: (
      <>
        <p>
          Ketika Anda mengunjungi Layanan Kami, kami secara otomatis dapat
          mengumpulkan informasi tambahan tentang Anda, seperti jenis ponsel
          atau sistem operasi yang Anda gunakan dan, jika Anda mengunjungi
          melalui situs web, kami secara otomatis juga dapat mengumpulkan
          informasi mengenai jenis peramban internet yang Anda gunakan dan situs
          web tempat Anda telah anda kunjungi sebelumnya untuk mengakses laman
          Kami.
        </p>
        <p>
          Selain dari itu juga kami dapat mengumpulkan informasi berdasarkan
          bagaimana Anda mengakses Layanan Kami di PC atau melalui perangkat
          seluler Anda, kami akan mengumpulkan alamat IP Anda (alamat unik yang
          mengidentifikasi komputer di rumah Anda di internet) atau pengenal
          unik (yang terkait dengan perangkat seluler Anda) yang secara otomatis
          dikenali oleh server kami. Anda tidak dapat diidentifikasi hanya dari
          informasi ini dan terkait informasi tersebut hanya digunakan untuk
          membantu kami dalam menyediakan layanan yang efektif pada Aplikasi dan
          untuk mengumpulkan informasi demografis yang luas untuk penggunaan
          agregat.
        </p>
        <p>
          Situs web menggunakan cookie untuk menyimpan informasi tertentu.
          Cookie adalah informasi yang ditransfer situs web ke hard drive Anda
          untuk disimpan dan terkadang melacak informasi tentang Anda. Meskipun
          cookie mengidentifikasi perangkat pengguna, cookie tidak
          mengidentifikasi pengguna secara pribadi. Cookie khusus untuk server
          yang membuatnya dan tidak dapat diakses oleh server lain, yang berarti
          cookie tidak dapat digunakan untuk melacak pergerakan Anda di
          internet.
        </p>
        <p>
          Untuk informasi lebih lanjut tentang bagaimana kami menggunakan cookie
          dan perangkat pelacak lainnya, silakan lihat Kebijakan Cookie kami.
        </p>
      </>
    ),
  },
  {
    id: "berbagi_informasi",
    title: "Berbagi Informasi",
    content: (
      <>
        <p>
          Kami dapat mengungkapkan statistik agregat tentang pengunjung Layanan
          Kami, pelanggan, dan penjualan untuk menjelaskan Layanan Kami kepada
          calon mitra, pengiklan, calon pedagang, dan pihak ketiga terkemuka
          lainnya dan untuk tujuan sah lainnya, tetapi statistik ini tidak akan
          menyertakan informasi yang dapat diidentifikasi secara pribadi.
        </p>
        <p>
          Kami dapat mengungkapkan informasi pribadi Anda kepada afiliasi,
          pedagang, atau agen atau kontraktor kami yang membantu kami dalam
          menyediakan layanan, memproses transaksi, memenuhi permintaan
          informasi, menerima dan mengirim komunikasi, memperbarui daftar
          pemasaran, menganalisis data, memberikan layanan dukungan atau dalam
          tugas lain, dari waktu ke waktu. Agen dan kontraktor kami hanya akan
          menggunakan informasi Anda sejauh yang diperlukan untuk menjalankan
          fungsinya.
        </p>
        <p>
          Jika kami mengalami reorganisasi atau dijual ke pihak ketiga, Anda
          setuju bahwa informasi pribadi apa pun yang kami miliki tentang Anda
          dapat ditransfer ke entitas yang direorganisasi atau pihak ketiga
          tersebut.
        </p>
        <p>
          Kami dapat mengungkapkan informasi pribadi Anda jika diminta untuk
          melakukannya oleh hukum atau jika kami yakin bahwa tindakan tersebut
          diperlukan untuk mencegah penipuan atau kejahatan dunia maya atau
          untuk melindungi Layanan Kami atau menegakkan ketentuan di mana Anda
          bertransaksi dengan kami atau menegakkan hak, properti atau
          keselamatan pribadi setiap orang.
        </p>
      </>
    ),
  },
  {
    id: "forum_publik",
    title: "Forum Publik",
    content: (
      <>
        <p>
          Layanan kami, dari waktu ke waktu, menyediakan forum publik (yaitu
          rating dan review). Setiap informasi yang diungkapkan di area ini
          menjadi informasi publik dan Anda harus berhati-hati saat menggunakan
          ini dan jangan pernah mengungkapkan informasi pribadi Anda.
        </p>
      </>
    ),
  },
  {
    id: "link_eksternal",
    title: "Link Eksternal",
    content: (
      <>
        <p>
          Layanan kami dari waktu ke waktu memungkinkan memiliki link ke situs
          eksternal. Kami tidak bertanggung jawab atas kebijakan privasi atau
          konten situs tersebut. Harap dicatat bahwa setelah Anda meninggalkan
          Layanan Kami dan menautkan ke situs web lain, Anda tunduk pada
          kebijakan privasi situs baru tersebut.
        </p>
      </>
    ),
  },
  {
    id: "situs_dan_konten_pihak_ketiga",
    title: "Situs dan Konten Pihak Ketiga",
    content: (
      <>
        <p>
          Pengguna dapat menemukan konten yang diposting oleh Pengguna lain,
          iklan, atau konten lain di Layanan kami yang tertaut ke situs dan
          layanan mitra, pemasok, pengiklan, sponsor, pemberi lisensi, dan pihak
          ketiga lainnya (secara bersama-sama, "Pihak Ketiga Isi"). Kami tidak
          mengontrol konten atau tautan Konten Pihak Ketiga yang muncul di situs
          ini dan tidak bertanggung jawab atas praktik yang dilakukan oleh situs
          web yang ditautkan ke atau dari Layanan kami atau konten yang
          diposting oleh Pengguna lain. Selain itu, situs atau layanan ini,
          termasuk konten dan tautannya, dapat terus berubah. Situs dan layanan
          ini mungkin memiliki kebijakan privasi dan kebijakan layanan
          pelanggannya sendiri. Penelusuran dan interaksi di situs web lain atau
          Konten Pihak Ketiga, termasuk situs web yang memiliki tautan ke
          Layanan kami, tunduk pada syarat dan kebijakan situs web itu sendiri.
        </p>
        <p>
          Pengguna, termasuk Merchant, dapat memposting Konten Pihak Ketiga pada
          Layanan. Kami dapat mengambil tindakan untuk menghapus Konten Pihak
          Ketiga, termasuk yang diposting oleh Merchant, jika ditemukan konten
          yang tidak benar, curang, atau spam. Pengguna dapat memberi tahu kami
          jika mereka yakin Konten Pihak Ketiga harus dihapus karena melanggar
          Persyaratan Layanan. Namun, kami tidak dapat memantau semua Konten
          Pihak Ketiga dan tidak berkewajiban untuk menghapus Konten tersebut.
          Ketika Anda setuju untuk mengakses Konten Pihak Ketiga termasuk daftar
          aktivitas, berarti Anda menyetujui risiko yang mungkin terjadi.
        </p>
      </>
    ),
  },
  {
    id: "pemasaran_kepada_anda",
    title: "Pemasaran Kepada Anda",
    content: (
      <>
        <p>
          Kami dapat mengirimkan informasi yang menurut kami berguna bagi Anda
          atau yang Anda minta dari kami melalui pemberitahuan dan/atau (jika
          Anda memberikan alamat email Anda) melalui email, termasuk informasi
          tentang informasi terbaru atau acara mendatang yang ditampilkan di
          Layanan Kami, asalkan Anda telah menunjukkan bahwa Anda tidak
          keberatan dihubungi untuk tujuan ini dan kami akan selalu memberi Anda
          opsi untuk tidak menerima email lebih lanjut atau pemberitahuan push
          dengan mengikuti instruksi berhenti berlangganan pada komunikasi apa
          pun yang dikirim kepadamu.
        </p>
        <p>
          Kami juga dapat menggunakan buletin untuk memberi tahu Anda tentang
          perkembangan terkini dan memperkenalkan Layanan Kami, penawaran
          khusus, dan promosi. Anda dapat berhenti berlangganan buletin ini
          kapan saja dengan mengklik tautan 'Berhenti Berlangganan' di buletin
          atau, sebagai alternatif, dengan menghubungi kami melalui detail
          kontak kami yang tercantum di bagian bawah kebijakan privasi ini.
          Meskipun kami menghargai umpan balik yang Anda miliki, Anda tidak
          perlu memberikan alasan untuk berhenti berlangganan buletin kami.
        </p>
        <p>
          Selain itu, kami dapat mengizinkan pedagang kami, dan jika Anda setuju
          dengan memilih untuk menerima informasi dan penawaran tersebut, pihak
          ketiga lain yang dipilih dengan cermat, untuk mengirimi Anda informasi
          secara langsung yang mungkin berguna bagi Anda mengenai produk dan
          layanan mereka.
        </p>
        <p>
          Anda dapat memberi tahu kami untuk tidak menghubungi Anda mengenai
          informasi produk atau layanan pihak ketiga, atau untuk membagikan
          detail Anda dengan pihak ketiga sehingga mereka dapat secara langsung
          mengirimi Anda informasi mengenai produk dan layanan mereka, baik pada
          saat informasi tersebut dikumpulkan di Aplikasi (dengan mencentang
          kotak yang relevan), atau jika Anda tidak ingin kami terus menggunakan
          informasi Anda dengan cara ini dengan mengikuti instruksi berhenti
          berlangganan pada komunikasi apa pun yang dikirimkan kepada Anda.
        </p>
        <p>
          Anda juga dapat menggunakan hak ini kapan saja dengan menghubungi kami
          menggunakan detail kontak di bagian akhir kebijakan privasi ini.
        </p>
        <p>
          Saat Anda membeli tiket dari kami, Anda mungkin pada saat itu ditawari
          kesempatan untuk membeli produk atau layanan pihak ketiga atau
          mengikuti promosi atau program loyalitas pihak ketiga. Jika Anda
          secara tegas menyetujui untuk membeli produk atau layanan tersebut
          atau mengikuti promosi atau program, Anda mengizinkan kami untuk
          membagikan nama, alamat email Anda dan, detail keuangan dan penagihan
          Anda dengan pihak ketiga. Penggunaan informasi pribadi Anda akan
          diatur oleh ketentuan ketentuan pasokan dan kebijakan privasi pedagang
          itu sendiri, jadi pastikan Anda membaca ketentuan dan kebijakan
          privasi yang relevan dengan cermat sebelum Anda setuju untuk membeli
          dari, atau berpartisipasi dengan pedagang pihak ketiga tersebut.
        </p>
      </>
    ),
  },
  {
    id: "data_lokasi_anda",
    title: "Data Lokasi Anda",
    content: (
      <>
        <p>
          Untuk mendapatkan hasil maksimal dari layanan kami dan untuk
          memungkinkan kami memberikan penawaran yang disesuaikan kepada Anda,
          kami perlu memproses perkiraan lokasi Anda dari waktu ke waktu. Anda
          akan selalu diminta untuk memberikan izin sebelum kami dapat mengakses
          lokasi Anda dari perangkat seluler apa pun yang mungkin Anda gunakan.
          Data lokasi dapat ditransfer ke pedagang kami untuk tujuan memberikan
          Anda penawaran terbaik pada saat itu agar sesuai dengan preferensi
          Anda. Dengan membagikan lokasi Anda, kami dapat memberi Anda aktivitas
          menarik di lokasi area Anda.
        </p>
        <p>
          Anda dapat memilih untuk tidak mengizinkan kami memproses perkiraan
          lokasi Anda pada saat Anda menggunakan atau mengunjungi Layanan Kami,
          atau kapan pun setelah itu baik dengan mengubah pengaturan pada
          perangkat seluler Anda atau dengan menghubungi kami menggunakan detail
          kontak di bagian akhir privasi ini. Harap perhatikan bahwa jika Anda
          memilih untuk tidak mengizinkan kami memproses data lokasi Anda, kami
          tidak akan memiliki cukup data untuk memberi Anda manfaat penuh dari
          layanan kami (misalnya daftar penawaran yang disesuaikan dengan
          perkiraan lokasi Anda).
        </p>
      </>
    ),
  },
  {
    id: "akses_perbarui_hapus_data",
    title:
      "Bagaimana Anda Dapat Mengakses, Memperbarui, atau Menghapus Data Pribadi Anda",
    content: (
      <>
        <p>
          Anda dapat meminta akses ke beberapa Data Pribadi Anda yang disimpan
          oleh kami. Anda juga dapat meminta kami untuk memperbaiki,
          memperbarui, atau menghapus Data Pribadi yang tidak akurat yang kami
          proses tentang Anda.
        </p>
        <p>
          Jika Anda adalah Merchant terdaftar, Anda dapat menggunakan hak ini
          dengan masuk dan mengunjungi halaman profil Anda di bawah pengaturan
          Akun Anda. Jika Anda adalah Pelanggan yang menghadiri suatu acara dan
          terdaftar pada acara tersebut melalui Layanan; dan jika Anda juga
          telah mendaftar ke portal Layanan Mandiri untuk peserta, beberapa Data
          Pribadi Anda mungkin tersedia untuk diedit tergantung pada apakah
          Merchant acara mengizinkannya atau tidak. Jika tidak, Anda dapat
          menghubungi Penjual aktivitas secara langsung untuk menggunakan hak
          ini.
        </p>
        <p>
          Jika Pelanggan mengajukan permintaan penghapusan data, kami berwenang
          untuk menghapus atau menganonimkan Data Pribadi Pelanggan yang meminta
          dari Layanan bahkan jika itu berarti menghapus ketersediaannya kepada
          Merchant melalui Layanan. Namun, jika Anda adalah Pelanggan, Anda
          memahami bahwa meskipun kami menghapus atau menganonimkan Data Pribadi
          Anda atas permintaan Anda atau sesuai dengan Kebijakan ini, Data
          Pribadi Anda mungkin masih tersedia di database Merchant sendiri jika
          dikirimkan ke Merchant sebelum kami menerima atau mengambil tindakan
          pada aktivitas penghapusan atau anonimisasi apa pun.
        </p>
        <p>
          Jika Anda menghadapi masalah saat mengakses dan memperbarui data
          pribadi Anda, jangan ragu untuk menghubungi kami, hello@sodtix.com.
        </p>
      </>
    ),
  },
  {
    id: "perubahan_kebijakan_privasi",
    title: "Perubahan Kebijakan Privasi Ini",
    content: (
      <>
        <p>
          Kami berhak untuk membuat perubahan kebijakan privasi ini setiap saat
          dengan memberikan pemberitahuan kepada Pengguna di halaman ini. Sangat
          disarankan untuk sering memeriksa halaman ini, mengacu pada tanggal
          modifikasi terakhir yang tercantum di bagian bawah.
        </p>
      </>
    ),
  },
  {
    id: "keamanan",
    title: "Keamanan",
    content: (
      <>
        <p>
          Kami berkomitmen untuk menjaga data pribadi Anda dari penggunaan yang
          tidak sah, modifikasi, publikasi atau penghapusan data tersebut. Untuk
          mencapai tingkat perlindungan yang tinggi, kami mengambil berbagai
          langkah keamanan fisik dan teknis. Kami sangat mementingkan keamanan
          semua informasi pengenal pribadi yang terkait dengan pengguna kami.
          Kami memiliki langkah-langkah keamanan untuk mencoba melindungi dari
          kehilangan, penyalahgunaan, dan perubahan informasi pribadi di bawah
          kendali kami. Misalnya, kebijakan keamanan dan privasi kami ditinjau
          dan ditingkatkan secara berkala jika diperlukan dan hanya personel
          yang berwenang yang memiliki akses ke informasi pribadi. Meskipun kami
          tidak dapat memastikan atau menjamin bahwa kehilangan, penyalahgunaan,
          atau perubahan informasi tidak akan pernah terjadi, kami menggunakan
          semua upaya yang wajar untuk mencegahnya.
        </p>
        <p>
          Anda harus ingat bahwa pengiriman informasi melalui internet tidak
          pernah sepenuhnya aman. Kami tidak dapat menjamin keamanan informasi
          yang Anda kirimkan pada Layanan Kami saat sedang transit melalui
          internet dan setiap pengiriman tersebut merupakan risiko Anda sendiri.
        </p>
      </>
    ),
  },
  {
    id: "hak-anda",
    title: "Hak Anda",
    content: (
      <>
        <p>
          Anda memiliki hak untuk memperbaiki kesalahan dalam informasi yang
          kami simpan mengenai Anda. Seperti yang disebutkan sebelumnya, Anda
          juga memiliki hak untuk mencegah penggunaan informasi pribadi Anda
          untuk tujuan pemasaran langsung. Kami menghargai privasi Anda, dan
          jika Anda tidak setuju dengan ketentuan Kebijakan Privasi ini, kami
          menghimbau Anda untuk tidak menggunakan Layanan Kami.
        </p>
      </>
    ),
  },
  {
    id: "kebijakan-cookies",
    title: `Kebijakan ${brandConfig.appName} Cookies`,
    content: (
      <>
        <p>
          Kami ingin Anda menikmati pengalaman Anda saat mengunjungi platform
          kami, dan kami menggunakan cookie untuk memastikan bahwa Layanan Kami
          (situs web {brandConfig.prodUrl}, dll.) berjalan dengan lancar dan andal.
          Ketika Anda berinteraksi dengan Layanan Kami, kami berusaha untuk
          membuat pengalaman Anda sederhana dan bermakna.
        </p>
        <p>
          Saat Anda mengunjungi Layanan Kami, server Web kami mengirimkan cookie
          ke komputer atau perangkat seluler Anda (tergantung cara Anda
          mengaksesnya). Cookie adalah informasi kecil yang dikeluarkan ke
          komputer Anda saat Anda mengunjungi situs web dan yang menyimpan serta
          terkadang melacak informasi tentang penggunaan situs oleh Anda.
        </p>
        <p>
          Beberapa cookie yang kami gunakan hanya bertahan selama sesi web Anda
          dan kedaluwarsa saat Anda menutup aplikasi Anda. Ini dikenal sebagai
          cookie sesi. Cookie lain digunakan untuk mengingat Anda ketika Anda
          kembali ke aplikasi dan akan bertahan lebih lama. Ini dikenal sebagai
          cookie persisten.
        </p>
        <p>
          Kami menggunakan cookie untuk:
          <ul>
            <li>
              Mengingat bahwa Anda telah mengunjungi kami sebelumnya, yang
              memungkinkan kami untuk mengidentifikasi jumlah pengunjung unik
              yang kami terima.
            </li>
            <li>
              Menyesuaikan elemen tata letak promosi dan/atau konten halaman
              situs.
            </li>
            <li>
              Mengumpulkan informasi statistik tentang bagaimana Anda
              menggunakan situs sehingga kami dapat meningkatkan situs dan
              mempelajari bagian mana dari situs web yang paling populer bagi
              pengunjung.
            </li>
          </ul>
        </p>
        <p>
          Beberapa cookie yang digunakan oleh Layanan Kami diatur oleh kami, dan
          beberapa diatur oleh pihak ketiga yang memberikan layanan atas nama
          kami. Misalnya, situs jejaring sosial.
        </p>
        <p>
          Sebagian besar browser web secara otomatis menerima cookie, tetapi
          jika Anda mau, Anda dapat mengubah pengaturan browser Anda untuk
          mencegahnya atau memberi tahu Anda setiap kali cookie disetel. Anda
          juga dapat mempelajari lebih lanjut tentang cookie dengan mengunjungi{" "}
          <a
            href="http://www.allaboutcookies.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.allaboutcookies.org
          </a>
          , yang mencakup informasi tambahan yang berguna tentang cookie dan
          cara memblokirnya menggunakan berbagai jenis browser.
        </p>
        <p>
          Harap dicatat bahwa dengan memblokir atau menghapus cookie yang
          digunakan di situs kami, Anda mungkin tidak dapat memanfaatkan Layanan
          Kami sepenuhnya.
        </p>
        <p>
          Selain cookie, Gif pelacakan dapat diatur oleh kami atau pihak ketiga
          sehubungan dengan penggunaan situs oleh Anda. Gif Pelacakan adalah
          file gambar kecil dalam konten situs kami atau isi buletin kami yang
          memungkinkan kami atau pihak ketiga memahami bagian mana dari situs
          web yang dikunjungi atau apakah konten tertentu menarik.
        </p>
        <p>
          Silakan lihat juga kebijakan privasi kami yang memberikan detail
          tentang bagaimana kami menggunakan informasi pribadi yang Anda berikan
          kepada kami.
        </p>
      </>
    ),
  },
  {
    id: "menghubungi-kami",
    title: "Menghubungi Kami",
    content: (
      <>
        <p>
          Kami mengontrol data pribadi Anda di situs web dan aplikasi lain yang
          memfasilitasi Layanan Kami. Jika Anda memiliki pertanyaan, masalah,
          atau komentar mengenai kebijakan privasi ini atau permintaan terkait
          data pribadi Anda, silakan hubungi kami melalui salah satu cara
          berikut:
        </p>
        <ul>
          <li>
            Email: <a href="mailto:hello@sodtix.com">hello@sodtix.com</a>
          </li>
          <li>
            Alamat: Rawa Papan Residence, Jl. H. Leman No.139 A, RW.6, Bintaro,
            Pesanggrahan, Jakarta Selatan, Jakarta 12330
          </li>
        </ul>
      </>
    ),
  },
];

export default function Privacy() {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  // Scroll to a specific section
  const handleLinkClick = (id: string) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <MainLayout>
      <Helmet>Kebijakan Privasi</Helmet>
      <Breadcrumb
        label="Kebijakan Privasi"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Kebijakan Privasi", href: "#" },
        ]}
      />
      <div className="container-privacy">
        {/* Links on the top, above the content */}
        <div className="links-privacy">
          {sections.map((section) => (
            <a
              key={section.id}
              href={`#${section.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleLinkClick(section.id);
              }}
              className={`link-privacy ${
                activeSection === section.id ? "active" : ""
              }`}
            >
              {section.title}
            </a>
          ))}
        </div>

        {/* Right-side content */}
        <div className="content-privacy">
          {sections.map((section) => (
            <div
              id={section.id}
              key={section.id}
              className={`section ${
                activeSection === section.id ? "highlight" : ""
              }`}
            >
              <h2>{section.title}</h2>
              {section.content}
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
